// extracted by mini-css-extract-plugin
export default {"downloadButtonWrapper":"efileTransmissionStatus_downloadButtonWrapper__EXq77"};